import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import LeftNav from './LeftNav';
// import Details from './EditProfile/ProfileDetails';
// import EditPaymentForm from './EditProfile/EditPaymentForm';
import EditAddressForm from './EditProfile/EditAddressForm';
import EditClubPickUpAddressForm from './EditProfile/EditClubPickUpAddressForm';
import moment from 'moment';
import MetaTags from 'react-meta-tags';
import Loading from '../../ui/Loading';
import MetaLoader from '../../ui/MetaLoader';
const formatPhoneNumber = require('../../../utils/formatNumber').handler;

const getInitialValues = (
  {
    FirstName: name_first,
    LastName: name_last,
    City,
    Address1,
    Address2,
    Label,
    Company,
    Zip,
    Phone,
    StateID,
    DOB,
    IsClubAddress: isClubAddress,
    IsDefaultMailing: isDefaultMailing,
    IsDefaultShipping: isDefaultShipping
  }
) => {
  //convert dob to seperate fields
  const dob = moment(DOB);
  const dobYear = dob.year();
  const dobDay = dob.date();
  const dobMonth = dob.month();

  return {
    name_first,
    name_last,
    City,
    Address1,
    Address2,
    Label,
    Company,
    Zip,
    Phone: formatPhoneNumber(Phone),
    StateID,
    dobDay,
    dobMonth,
    dobYear,
    isDefaultShipping,
    isDefaultMailing,
    isClubAddress
  };
};

class EditAddressBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchAddress: true,
      searchValue: '',
      address1: ''
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);

    this.props.getLookups();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-add-address',
      'page-template-page-templatesshop-template-my-account-add-address-php',
      'page',
      'page-id-257',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-add-address',
      'page-template-page-templatesshop-template-my-account-add-address-php',
      'page',
      'page-id-257',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }

  render() {
    const {
      postAddress,
      putAddress,
      putAddressError,
      clearPutAddress,
      postAddressError,
      user,
      lookups,
      inProgress,
      history,
      match: { params },
      getAddressSuggestions,
      getAddressSuggestionsResult
    } = this.props;

    const { id } = params || {};

    const {
      searchAddress,
      searchValue
    } = this.state;

    const {
      userId,
      AddressBook,
      ClubMember,
      IsActiveClubMember
    } = user || {};
    const { IsWillCallOnly, WillCallLocation } = ClubMember || {};
    const scrollToTop = () => window.scrollTo(0, 0);

    const address = (AddressBook || [])
      .find(({ AddressBookID }) => AddressBookID === parseInt(id)) || {};
    const initialValues = getInitialValues(address || {});
    const { isClubAddress } = initialValues || {};
    const { AddressBookID } = address || {};
    const willCallOnlyInitialValues = {
      switchToShipping: false,
      isClubAddress: true,
      Label: 'Club Shipping'
    }

    const handlePutAddress = values => {
      putAddress(
        { payload: { ...values, IsActiveClubMember }, id: userId, addressId: AddressBookID },
        'edit-address-form',
        null,
        () => history.push('/account/edit-profile/address-book')
      );
    }
    const handleUpdateClubAddress = (values) => {
      const { shippingAddressBookId } = values || {};
      if (shippingAddressBookId === 'addNew') {
        postAddress(
          { payload: { ...values, IsActiveClubMember }, id: userId, addressId: AddressBookID },
          'edit-address-form',
          null,
          () => history.push('/account/edit-profile/address-book')
        );
      } else {
        putAddress(
          { payload: { ...values, IsActiveClubMember }, id: userId, addressId: AddressBookID },
          'edit-address-form',
          null,
          () => history.push('/account/edit-profile/address-book')
        );
      }
    }

    const navBackToAddressBook = () =>
      history.push('/account/edit-profile/address-book');


    const handleGetAddressSuggestions = async (value) => {
      this.setState({ searchValue: value });
      if ((value || []).length > 2) {
        await getAddressSuggestions({ searchText: value });
      }
    };
    const handleSelect = ({ address1, searchAddress }) => {
      this.setState({ address1: address1, searchAddress: searchAddress });
    }
    return (
      <div id="content" className="site-content">
        <MetaLoader title="Manage Address Book | Account | Twomey" />
        <MetaTags>
          <title>Manage Address Book | Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta
            property="og:title"
            content="Manage Address Book | Account | Twomey"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/edit-profile/address-book"
          />
        </MetaTags>
        <div id="primary" className="content-area">

          <main id="main" className="site-main account-page nohero">
            <div className="container">
              <div className="row">

                <LeftNav />

                {inProgress && <Loading fullPage scrollToTop />}
                {!inProgress && (!isClubAddress || (isClubAddress && !IsWillCallOnly)) &&
                  <EditAddressForm
                    onSubmit={handlePutAddress}
                    errorSubmit={putAddressError}
                    initialValues={initialValues}
                    editType={'Edit'}
                    toggle={navBackToAddressBook}
                    lookups={lookups}
                    addressBook={AddressBook}
                    IsWillCallOnly={IsWillCallOnly}
                    address={address}
                    clearPutAddress={clearPutAddress}
                    handleSelect={handleSelect}
                    searchValue={searchValue}
                    searchAddress={searchAddress}
                    getAddressSuggestionsResult={getAddressSuggestionsResult}
                    handleGetAddressSuggestions={handleGetAddressSuggestions}
                  />
                }

                {!inProgress && isClubAddress && IsWillCallOnly &&
                  <EditClubPickUpAddressForm
                    onSubmit={handleUpdateClubAddress}
                    errorSubmit={putAddressError}
                    initialValues={willCallOnlyInitialValues}
                    editType={'Edit'}
                    toggle={navBackToAddressBook}
                    lookups={lookups}
                    IsWillCallOnly={IsWillCallOnly}
                    WillCallLocation={WillCallLocation}
                    addressBook={AddressBook}
                    address={address}
                    handleSelect={handleSelect}
                    searchValue={searchValue}
                    searchAddress={searchAddress}
                    getAddressSuggestionsResult={getAddressSuggestionsResult}
                    handleGetAddressSuggestions={handleGetAddressSuggestions}
                  />}
              </div>
            </div>
          </main>

        </div>
        <div className="container text-right">
          <a href="#top" className="back-to-top" onClick={scrollToTop}>
            Back to top
          </a>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    error: postAddressError
  } = state.postAddress.toJS();

  const {
    error: putAddressError,
    inProgress: editAddressInProgress
  } = state.putAddress.toJS();

  const {
    result: user,
    inProgress: userInProgress
  } = state.postLogin.toJS();

  const {
    // error,
    inProgress: lookupsInProgress,
    result: lookups
  } = state.getLookups.toJS();

  const {
    result: getAddressSuggestionsResult
  } = state.getAddressSuggestions.toJS();
  return {
    lookups,
    postAddressError,
    putAddressError,
    user,
    inProgress: lookupsInProgress || userInProgress,
    getAddressSuggestionsResult
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postAddress: fetchDux.postAddress.createAction,
      putAddress: fetchDux.putAddress.createAction,
      clearPutAddress: fetchDux.putAddress.clearAction,
      getLookups: fetchDux.getLookups.createAction,
      getAddressSuggestions: fetchDux.getAddressSuggestions.createAction,
      clearGetAddressSuggestions: fetchDux.getAddressSuggestions.clearAction,
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(EditAddressBook);
